import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandSAP(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M1.2 7.2v10.2h10.917L22.8 7.2H1.2Zm2.938 1.897h.004c.777 0 1.724.21 2.409.544l-.738 1.229c-.752-.348-1.13-.38-1.557-.402-.638-.032-.958.185-.962.42-.007.285.602.543 1.174.72.868.262 1.971.614 2.14 1.632l1.585-4.001h1.842l1.857 4.79-.006-4.79h2.133c2.031 0 2.986.657 2.986 2.165 0 1.353-.98 2.16-2.642 2.16h-.687l-.009 1.799-3.23-.003-.224-.78a3.7 3.7 0 0 1-1.107.163c-.41 0-.797-.061-1.137-.172l-.322.79-1.8.005.08-.397c-.025.021-.05.043-.077.063-.482.37-1.088.54-1.834.553l-.191.002a4.738 4.738 0 0 1-2.323-.58l.657-1.244c.71.401 1.157.492 1.76.48.312-.006.538-.06.685-.206a.468.468 0 0 0 .14-.317c.007-.323-.477-.475-1.066-.65-.478-.14-1.022-.334-1.446-.63-.503-.353-.742-.795-.73-1.418a1.67 1.67 0 0 1 .51-1.183c.466-.462 1.22-.742 2.126-.742Zm9.537 1.435v1.636h.469c.625 0 1.122-.198 1.123-.829 0-.609-.498-.807-1.123-.807h-.469Zm-4.578.659-.673 2.03c.2.072.432.113.68.113.242 0 .469-.04.669-.108L9.11 11.19h-.013Z"
        fill="#0FAAFF"
      />
    </BaseIcon>
  );
}
